import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import TextareaField from "../../components/TextareaField/TextareaField";
import { MessagesPrivate } from "../../services/services";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";

const ModalSendMessageUser = ({
  modalSendMessage,
  setModalSendMessage,
  userIdList,
}) => {
  const [messageUser, setMessageUser] = useState({
    type: "",
    content: "",
  });

  const orderByOptions = [
    { label: "اس ام اس", value: "0" },
    { label: "نوتیفیکیشن", value: "1" },
    { label: "برای اپلیکیشن", value: "3" },
  ];

  const handleHide = () => {
    setModalSendMessage(false);
    setMessageUser({ type: "", content: "" });
  };

  const handleSubmit = async () => {
    const trimmedContent = messageUser.content.trim();

    if (!messageUser.type || !trimmedContent || !userIdList?.length) return;

    try {
      await MessagesPrivate({
        content: trimmedContent,
        type: messageUser.type,
        receiverUserIds: userIdList,
      });

      handleHide();
    } catch (error) {
      console.error("MessagesPrivate error:", error);
      // اینجا می‌تونی نوتیف خطا بزاری
    }
  };

  const isDisabled =
    !messageUser.type || !messageUser.content.trim() || !userIdList?.length;

  return (
    <Dialog
      header={`تعداد مخاطبان پیام: ${userIdList?.length ?? 0} نفر`}
      visible={modalSendMessage}
      style={{ width: "20vw", height: "16vw" }}
      maximizable
      modal
      contentStyle={{ height: "300px", overflowX: "hidden" }}
      onHide={handleHide}
      className="farsi-monospace-digit custom-dialog"
    >
      <div className="row justify-content-center mx-4 mt-4">
        <SelectCustom
          name="type"
          placeholder="نوع پیام"
          isClearable={true}
          isSearchable={false}
          unstyled={true}
          options={orderByOptions}
          value={
            orderByOptions.find((item) => item.value === messageUser.type) ||
            null
          }
          onChange={(selected) => {
            setMessageUser((prev) => ({
              ...prev,
              type: selected ? selected.value : "",
            }));
          }}
        />

        <TextareaField
          value={messageUser.content}
          classNameBox="mt-4 "
          label="متن پیام"
          onChange={(e) =>
            setMessageUser((prev) => ({
              ...prev,
              content: e.target.value,
            }))
          }
        />
      </div>

      <div className="row justify-content-center">
        <button
          style={{
            color: "#ffffff",
            background: "#86a0ff",
            border: 0,
            width: "68px",
            borderRadius: "8px",
            padding: "4px 0",
            marginTop: "20px",
            cursor: isDisabled ? "not-allowed" : "pointer",
            opacity: isDisabled ? 0.5 : 1,
          }}
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          ثبت
        </button>
      </div>
    </Dialog>
  );
};

export default ModalSendMessageUser;
